import React from 'react'
import ReactModal from 'react-modal'
import { connect } from 'react-redux'
import styles from '@style/PopSlidein/index.scss'
import Comment from './Comment'

class CommentDialog extends React.PureComponent {
  render() {
    const { isOpen, comment, close, submit } = this.props

    return (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={close}
        closeTimeoutMS={300}
        className="Modal"
        overlayClassName="Overlay"
        ariaHideApp={false}
        bodyOpenClassName="ReactModal__Body--open"
        id="popapp-popslidein"
      >
        <style jsx>{styles}</style>
        <Comment comment={comment && comment.toJS()} closePop={close} submit={submit} />
      </ReactModal>
    )
  }
}

function mapStateToProps(state) {
  const commentId = state.place.get('editingCommentId')
  const comment = state.place.getIn(['comments', commentId])
  return {
    comment,
  }
}

export default connect(mapStateToProps)(CommentDialog)
